import type { WeddingPhoto } from "../../shared/contracts";

export function gallerySrcset(photo: WeddingPhoto, format: "avif" | "webp"): string {
  return photo.variants.map((variant) => `${variant[format]} ${variant.width}w`).join(", ");
}

// Match the gallery's column spans, shell gutters, gaps and print borders.
// object-fit: cover may scale a portrait by height in a narrow, tall card;
// account for that scale as well as the element's width when choosing pixels.
export function gallerySizes(photo: WeddingPhoto, index: number): string {
  const lead = index < 2;
  const wide = lead || index === 8 || index === 9;
  const tall = lead || index >= 10;
  const ratio = photo.width / photo.height;
  const cover = (width: string, height: number) => `max(${width}, ${Math.ceil(height * ratio)}px)`;
  return [
    `(max-width: 520px) ${cover(lead ? "calc(100vw - 50px)" : "calc(50vw - 36px)", lead ? 352 : 165)}`,
    `(max-width: 760px) ${cover(lead ? "calc(100vw - 50px)" : "calc(50vw - 36px)", lead ? 422 : 200)}`,
    `(max-width: 1100px) ${cover(wide ? "calc(50vw - 57px)" : "calc(25vw - 46.5px)", tall ? 448 : 206)}`,
    `(max-width: 1466px) ${cover(wide ? "calc(50vw - 73px)" : "calc(25vw - 54.5px)", tall ? 448 : 206)}`,
    cover(wide ? "660px" : "312px", tall ? 448 : 206),
  ].join(", ");
}
